import pullAllBy from "lodash/pullAllBy";
import { Notification } from "@Types/notifications";

export type NotificationType = "error" | "validation" | "warning";

export interface NotificationData {
  code: string;
  developerMessage: string;
  type: NotificationType;
  undoable?: boolean;
  autoClose?: boolean;
}

export const notificationDatas: NotificationData[] = [
  {
    autoClose: true,
    code: "CFV-001",
    developerMessage: "Great, it worked!",
    type: "validation",
  },
  {
    autoClose: true,
    code: "CFE-001",
    developerMessage: "Unknown warning.",
    type: "error",
  },
  {
    autoClose: true,
    code: "CFE-002",
    developerMessage: "Check required fields",
    type: "error",
  },
  {
    autoClose: true,
    code: "CFE-003",
    developerMessage: "This email is different from the original email",
    type: "error",
  },
  {
    autoClose: true,
    code: "CFE-004",
    developerMessage: "We couldn't change your address - please try again",
    type: "error",
  },
  {
    autoClose: true,
    code: "CFE-005",
    developerMessage: "Sorry, we don't ship to this country yet!",
    type: "error",
  },
  {
    autoClose: true,
    code: "CFE-006",
    developerMessage: "Please enter a valid email address",
    type: "error",
  },
  {
    autoClose: true,
    code: "CFE-007",
    developerMessage: "Please enter a valid email address in the format yourname@example.com",
    type: "error",
  },
  {
    autoClose: true,
    code: "CFE-008",
    developerMessage: "Your password should contain at least 8 characters, safety first",
    type: "error",
  },
];

export const getNotificationData = (code: string): NotificationData => {
  const notificationData = notificationDatas.find((data) => data.code === code);
  if (!notificationData) {
    throw new Error(`Notification not found for code ${code}`);
  }

  return notificationData;
};

export const addNotificationRemovingSameOnes = (
  notifications: Notification[],
  notification: Notification
): void => {
  removeNoAutoCloseNotificationsByCode(notifications, notification.code);
  notifications.push(notification);
};

export const removeNoAutoCloseNotificationsByCode = (
  notifications: Notification[],
  code: string
): void => {
  const notificationData = getNotificationData(code);
  if (notificationData.autoClose) {
    return;
  }
  pullAllBy(notifications, [{ code }], "code");
};
